import { createPortal } from 'react-dom';
import type { MutableRefObject } from 'react';
import YearGroup from './YearGroup';

type TypeYearPickerImplProps = {
  hookRef: MutableRefObject<null>;
  fieldNamePrefix: string;
};


function TypeYearPickerImpl(props: TypeYearPickerImplProps) {
  const { hookRef, fieldNamePrefix } = props;

  if (!hookRef.current) {
    return null;
  }

  return (
    <>
      {createPortal(
        <YearGroup fieldNamePrefix={`${fieldNamePrefix}.yearRepeat.0.dtRanges`} />,
        hookRef.current!,
      )}
    </>
  );
}

export default TypeYearPickerImpl;
